import { render, staticRenderFns } from "./WxjkBenefitMore.vue?vue&type=template&id=7d82c6b0&scoped=true&"
import script from "./WxjkBenefitMore.vue?vue&type=script&lang=js&"
export * from "./WxjkBenefitMore.vue?vue&type=script&lang=js&"
import style0 from "./WxjkBenefitMore.vue?vue&type=style&index=0&id=7d82c6b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d82c6b0",
  null
  
)

export default component.exports